import styled, { createGlobalStyle, css } from "styled-components";
import { Switch } from "antd";

export const NewNotificationGlobalStyles = createGlobalStyle`
  .ant-table-footer {
    padding: 4px 0 0 0 !important;
  }
`;

export const SwitchStyled = styled(Switch)`
  margin-right: 6px;

  ${({ checked }) => checked && css`
    background-color: ${({ theme }) => theme.colors.primary.primary} !important;
  `}
`;

export const Space = styled.div`
  height: 15px;
`;

export const WrapperTable = styled.div`
  margin: 0 24px;

  p {
    margin: 0;
  }

  .tableContainer {

    .listTable {

      .fileListRow {

        .ant-table-cell {
          display: flex;
          align-items: center;
          min-height: 56px !important;
          
          &:first-child {
            padding-left: 20px !important;
          }

        }

        thead {
          
          tr {
            height: 38px !important;
            
            th {
              text-transform: capitalize !important;
              padding-left: 14px !important;
            }
          }
        }
        
        div div &:hover {
      
          .notificationBadge {
            display: none !important;
          }
    
          .readSpan {
            display: flex !important;
          }
        }
      }
    }

    .footerTable {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }
`;


export const ActionRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;

  .actionMessage {
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
    margin-left: 10px;
  }
`;

export const ContentRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  cursor: pointer;

  p {
    margin-left: 8px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

export const UserRow = styled.div`
  display: flex;
  align-items: center;
  
  p {
    margin-left: 8px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

export const DateRow = styled.div`
  display: flex;
  align-items: center;
`;

export const ReadRow = styled.div`
  display: flex;
  align-items: center;

  .notificationBadge {
    width: 6px;
    height: 6px;
    border-radius: 9.5px;
    background-color: ${({ theme }) => theme.colors.notification.notification};
  }
  
  .readSpan {
    width: 24px;
    height: 24px;
    display: none;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    margin-left: -8px;
    border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
    background-color: ${({ theme }) => theme.colors.surface.surface};
    cursor: pointer;

    .iconReadNotification {
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
    }
  }
`;

export const LogoCoodly = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
`;
